import { Box, Button, Flex, Image, Stack, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSocialWallet } from '../../modules/common/hooks/useSocialWallet'
import { consumerPrimaryButtonStyle } from '../../modules/user/buttonStyle'
import { SubTitle } from '../../modules/user/labels/Subtitle'
import { Title } from '../../modules/user/labels/Title'
import { CleanOutlineButton } from '../../modules/user/buttons/CleanOutlineButton'
import UserSignupScreen from '../../modules/user/screens/SignUpScreen'

export default function PayLeafConsumerSignup() {
  return <UserSignupScreen></UserSignupScreen>

  const {
    inited,
    web3auth,
    isLoggedIn,
    userInfoRes,
    pubKey,
    balance,
    loginWithGoogle,
    loginWithGoogleRes,
  } = useSocialWallet()

  const router = useRouter()

  useEffect(() => {
    if (inited && isLoggedIn) {
      router.push('/app')
    }
  }, [inited, isLoggedIn])

  return (
    <Box minHeight={'100vh'} bg='#F6F9F5' position={'relative'}>
      <Flex justifyContent={'center'}>
        <Box maxWidth='480px' mt='2rem' padding='2rem'>
          <Flex justifyContent={'center'}>
            <Image
              width={['50%', '42%']}
              src='/icons/SAC_PayLeaf_Logo_app.svg'
              color='#28374B'
            ></Image>
          </Flex>
          <Stack spacing='2.4rem'>
            <Flex justifyContent={'center'}>
              <Image
                width={['94%', '84%']}
                src='/images/app/payment-illu.png'
              ></Image>
            </Flex>

            <Box>
              <Title textAlign='center'>
                <i>
                  Payments made easy <br></br>with PayLeaf
                </i>
              </Title>
              <SubTitle textAlign='center' mt='.6rem'>
                With PayLeaf, you can easily pay at any store with your phone.
                <br />
                Sign up now to get started.
              </SubTitle>
            </Box>

            <Flex justifyContent={'center'}>
              <CleanOutlineButton
                isLoading={loginWithGoogleRes.loading}
                bg='white'
                onClick={loginWithGoogle}
              >
                <Image
                  height='1.6rem'
                  mr='.2rem'
                  borderRadius={'full'}
                  src={'/images/app/g-logo.png'}
                />
                Login with Google
              </CleanOutlineButton>
            </Flex>
          </Stack>
        </Box>
      </Flex>
      <Box
        marginTop={'-250px'}
        overflow='hidden'
        width='100vw'
        height='380px'
        zIndex={'0'}
        backgroundImage="url('/images/app/shaped-green.svg')"
        backgroundPosition={'top'}
        backgroundSize={'140%'}
      ></Box>
    </Box>
  )
}
